import React, { FC, ReactElement } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { useDispatch, useSelector } from 'react-redux';
import {
  refreshToasts,
  selectToasts,
  ToastData,
  ToastType,
} from '@/store/system';
import classnames from 'classnames/bind';
import styles from './toasts-container.scss';

const cx = classnames.bind(styles);

type ToastsContainerProps = {
  children: ReactElement;
};

export const ToastsContainer: FC<ToastsContainerProps> = ({ children }) => {
  const toasts: ToastData[] = useSelector(selectToasts);
  const dispatch = useDispatch();

  const hideToast = (id: number) => {
    const updatedToasts = [...toasts.filter(t => t.id != id)];
    dispatch(refreshToasts(updatedToasts));
  };

  return (
    <>
      <ToastContainer className="p-4">
        {toasts
          .filter(t => !t.hidden)
          .map(toast => (
            <Toast
              key={toast.id}
              onClose={() => hideToast(toast.id!)}
              autohide
              delay={toast.delay}
              className={cx(
                [ToastType[toast.type ?? ToastType.Default]]
                  .toString()
                  .toLowerCase()
              )}
              show={!toast.hidden}>
              <section className={cx(['d-flex', styles.toastItemContainer])}>
                <section
                  className={cx([
                    styles.iconContainer,
                    'd-flex align-items-center justify-content-center',
                  ])}>
                  <span className={cx(['iconfont icon-ico-information1'])} />
                </section>
                <section className={cx([styles.messageContainer])}>
                  <div className={cx(['d-flex justify-content-between'])}>
                    <strong>{toast.title}</strong>
                    <small>{toast.subTitle}</small>
                  </div>
                  <div>{toast.msg}</div>
                </section>
                <section
                  onClick={() => hideToast(toast.id!)}
                  className={cx([
                    styles.closeContainer,
                    'd-flex align-items-center justify-content-center',
                  ])}>
                  <span className={cx(['iconfont icon-ico-delete'])} />
                </section>
              </section>
            </Toast>
          ))}
      </ToastContainer>
      {children}
    </>
  );
};
